$(function(){
	/*
	$("#global-search-form").on("submit", function(e){
		e.preventDefault();

		let keywords = $("#global-search-input").val();
		let site = "cegep";

		$.get(`/actions/sitesearch/search/index`, { query: keywords, site: site })
		//$.get(`http://cegepsearch.loc/actions/sitesearch/search/index`, { query: keywords, site: site })
			.done(function(response){
				console.log("Résultat :", response);
			})
			.fail(function(error){
				console.error("Erreur :", error);
			});
	});
	*/
});
